@if (multi()) {
  <div [formGroup]="formGroup()">
    @if (taskCategory$ | async; as tc) {
      <p-multiSelect [options]="tc"
        optionLabel="name_primary_language"
        placeholder="{{ placeHolder() }}"
        styleClass="{{ styleClass() }}"
        [formControl]="controlName()"
        aria-label="task-category-multi-select"
         />
    }
  </div>
} @else {
  <div [formGroup]="formGroup()">
    @if (taskCategory$ | async; as tc) {
      <p-select
        [options]="tc"
        optionLabel="name_primary_language"
        placeholder="{{ placeHolder() }}"
        styleClass="{{ styleClass() }}"
        [formControl]="controlName()"
        aria-label="task-category-dropdown"
        >
        <ng-template pTemplate="TaskCategory">
          @if (TaskCategory) {
            <div class="text-sm">
              {{ TaskCategory.name_primary_language }}
            </div>
          }
        </ng-template>
        <ng-template let-taskCategory pTemplate="item">
          <div class="text-sm">{{ taskCategory.name_primary_language }}</div>
        </ng-template>
      </p-select>
    }
  </div>
}

